import { useContext } from 'react';

import {
  VerticalRightsizingSettings,
  WorkloadDetailsContext,
} from '@cast/split-me/features/cluster/workload-optimization';

export const InventoryWorkloadVerticalAutoscaling = () => {
  const { workload } = useContext(WorkloadDetailsContext);

  if (!workload) {
    return null;
  }

  return <VerticalRightsizingSettings workload={workload} />;
};
